import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import axios from "axios";

const RevenueitemShowComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {action, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [costSourceDict, setCostSourceDict] = useState({});
  const [costStatusDict, setCostStatusDict] = useState({});
  const [receiptId, setReceiptId] = useState(null);

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    apiCall('get', '/api/v2/dictionary/revenue-source')
      .then(response => {
        const items = Array.isArray(response?.data?.data) ? response.data.data : (Array.isArray(response?.data) ? response.data : []);
        const map = items.reduce((acc, it) => {
          if (it?.key) acc[String(it.key)] = String(it.value ?? '');
          return acc;
        }, {});
        setCostSourceDict(map);
      })
      .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response));

    apiCall('get', '/api/v2/dictionary/revenue-status')
      .then(response => {
        const items = Array.isArray(response?.data?.data) ? response.data.data : (Array.isArray(response?.data) ? response.data : []);
        const map = items.reduce((acc, it) => {
          if (it?.key) acc[String(it.key)] = String(it.value ?? '');
          return acc;
        }, {});
        setCostStatusDict(map);
      })
      .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response));

    if (props?.initialValues) {
      setFormData(props.initialValues);
    }

    if (id && action === 'read') {
      setLoading(true);
      setReceiptId(null);
      apiCall('get', '/api/v2/revenue-item/' + id)
        .then(response => {
          const d = response.data.data;
          setFormData(d);
          props.onLoaded(d);
          window.App.setState({ props: d });

          const directId = d?.receipt?.id ?? null;

          const allocId = Array.isArray(d?.revenue_allocations)
            ? d.revenue_allocations.find(a => a?.receipt?.id)?.receipt?.id
            : null;
          setReceiptId(directId ?? allocId ?? null);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => setLoading(false));
    }
  }, [window.App.state.rerenderRevenueitemShow, id])

  return (
    <div className={"revenueitem-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="name">{t('columnName')}</label>
            <span className="p-d-block fake-input">
              {(() => {
                const text = formData?.name ?? '';
                  if (String(formData?.source) === 'RECEIPT_LINE' && receiptId) {
                    return (
                      <a href="#" onClick={(e) => { e.preventDefault(); history.push('/finance/receipt/read/' + receiptId); }}>
                        {text}
                      </a>
                    );
                  }
                return <>{text}</>;
              })()}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="source">{t('columnSource')}</label>
            <span className="p-d-block fake-input">
              {costSourceDict[String(formData?.source ?? '')] ?? formData?.source ?? ''}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="status">{t('columnStatus2')}</label>
            <span className="p-d-block fake-input">
              {costStatusDict[String(formData?.status ?? '')] ?? formData?.status ?? ''}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="amount">{t('columnAmount')}</label>
            <span className="p-d-block fake-input">
              {(() => {
                const amount = formData?.amount;
                const currency = formData?.currency || 'HUF';
                const num = Number(amount);
                if (amount === null || amount === undefined || Number.isNaN(num)) {
                  return '';
                }
                return window.App.currencyFormatter(currency, num);
              })()}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
export default withTranslation('common')(RevenueitemShowComponent);
